import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';
import { computed, observable, transaction } from 'mobx';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import i18n from '@i18next/i18n';
import type { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import type { IMasterLayoutEditService } from './master-layout-edit-service.interface';
import type { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import type { INoteAreaManager } from '@src/slide/application/service/note-area-manager/note-area-manager.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import {
    ISlideRenderStateManager, IStatePointEnum,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

export default class MasterLayoutEditService implements IMasterLayoutEditService {
    /**
     * 编辑模式，默认是幻灯片
     */
    @observable
    public editType = EDIT_TYPE.SLIDE;

    // eslint-disable-next-line no-useless-constructor
    public constructor(
        private uiDataService: IUiDataService,
        private selectionService: ISelectionService,
        private slideRenderStateManager: ISlideRenderStateManager,
        private noteAreaManager: INoteAreaManager,
    ) {}

    @computed
    public get isMasterEditType(): boolean {
        return this.editType === EDIT_TYPE.MASTER_LAYOUT;
    }

    public updateEditType(editType: string): void {
        this.editType = (editType ?? EDIT_TYPE.SLIDE);
    }

    public changeEditType = (editType: string): void => {
        if (editType === this.editType || !Object.values(EDIT_TYPE).includes(editType)) return;
        transaction(() => {
            if (this.isMasterEditType) {
                // 记录当前母版编辑的位置
                this.selectionService.lastMasterEditPageIndex = this.selectionService.currentSlideIndex;
                // 记录当前母版编辑的类型（版式/母版）
                if (this.selectionService.currentSlideType !== UIModelType.SLIDE) {
                    this.selectionService.lastMasterEditSlideType = this.selectionService.currentSlideType;
                }
                this.selectionService?.updateCurrentSlideType(UIModelType.SLIDE);
                this.updateEditType(EDIT_TYPE.SLIDE);
                if (this.selectionService) {
                    const slideLength = this.uiDataService?.slideModelList.length;
                    const currentIndex = slideLength ? this.selectionService.lastSlideEditPageIndex : -1;
                    this.selectionService.currentSlideIndex = currentIndex;
                }
            } else {
                if (!this.slideRenderStateManager?.getStatePoints()[IStatePointEnum.allSlideConvert].isCompleted) {
                    Snackbar.show({ message: i18n.t('母版正在加载中') });
                    return;
                }
                // 记录当前页编辑的位置
                this.selectionService.lastSlideEditPageIndex = this.selectionService.currentSlideIndex;
                this.selectionService?.selectedElements.clear();
                this.selectionService?.selectedSlides.clear();
                this.noteAreaManager?.setHide();
                this.selectionService?.updateCurrentSlideType(this.selectionService.lastMasterEditSlideType);
                this.updateEditType(EDIT_TYPE.MASTER_LAYOUT);
                if (this.selectionService) {
                    this.selectionService.currentSlideIndex = this.selectionService.lastMasterEditPageIndex;
                }
            }
            eventBus.emit(EventKeys.EDIT_TYPE_CHANGE, editType);
        });
    };

    public watchEditTypeChange = (callback: (editType: string) => void): void => {
        eventBus.on(EventKeys.EDIT_TYPE_CHANGE, callback);
    };
}
